import Axios from "../../../utils/axios";

export const getStatistics = (data) => {
  return (dispatch) => {
    Axios.get("/statistics/registration", dispatch, "GET_STATISTICS_REGISTRATIONS", data);
  };
};